import { Box, Typography } from '@mui/material'

import FeaturesContainer from '@ecm/ui/component/FeaturesContainer'
import CloudflareImage from '@ecm/ui/element/CloudflareImage'
import Color from '@ecm/ui/element/Color'

import automateIcon from '/public/images/icon/automate.svg'
import depositIcon from '/public/images/icon/deposit.svg'
import editIcon from '/public/images/icon/edit.svg'
import integrateIcon from '/public/images/icon/integrate.svg'
import notificationsIcon from '/public/images/icon/notifications.svg'
import organizeIcon from '/public/images/icon/organize.svg'
import scanningIcon from '/public/images/icon/scanning.svg'
import shareIcon from '/public/images/icon/share.svg'
import shipIcon from '/public/images/icon/ship.svg'

const features = [
  {
    description: (
      <>
        <b>Go to the check in your mailroom, click deposit,</b> choose (or add) your preferred bank
        account and submit—we’ll take it from there!
      </>
    ),
    icon: depositIcon,
    title: 'Check deposit requests',
  },
  {
    description: (
      <>
        Seamlessly forward mail and packages to an address of your choice. Plus, you can manage
        recipients and shipping addresses.
      </>
    ),
    icon: shipIcon,
    title: 'Requesting shipments',
  },
  {
    description: (
      <>
        Quick access to account activity including{' '}
        <b>
          unread items, check deposit status, pending shipments, items incurring storage fees, and
          more.
        </b>
      </>
    ),
    icon: organizeIcon,
    title: 'Insights dashboard',
  },
]

const moreFeatures = [
  {
    icon: automateIcon,
    title: 'Setup automations to streamline processes',
  },
  {
    icon: integrateIcon,
    title: 'Integrate with powerful software',
  },
  {
    icon: notificationsIcon,
    title: 'Notifications',
  },
  {
    icon: shareIcon,
    title: 'Share, download, or print PDFs',
  },
  {
    icon: scanningIcon,
    title: 'Scanning preferences',
  },
  {
    icon: editIcon,
    title: 'Edit a sender’s name to stay organized',
  },
]

const Features = () => (
  <FeaturesContainer
    header="Put your virtual mailbox to work for you, wherever you go!"
    headingMaxWidth="640px"
  >
    <Box
      mx="auto"
      my={{ md: '5em', xs: '3em' }}
      maxWidth={{ md: 'md', xs: 'sm' }}
      display="grid"
      gridTemplateColumns={{ md: 'repeat(3, 1fr)', xs: '1fr' }}
      gap="1.4em"
    >
      {features.map(({ title, description, icon }) => (
        <Box key={title} p="2em 1.5em" bgcolor={Color.saint.darkest} borderRadius="8px">
          <Box textAlign="center" mb="3em">
            <CloudflareImage src={icon} width={90} height={70} />
          </Box>
          <Typography variant="overline" color={Color.saint.lightest} mb="1em">
            {title}
          </Typography>
          <Typography variant="p3" color={Color.white.normal} mb="0">
            {description}
          </Typography>
        </Box>
      ))}
    </Box>

    <Typography variant="h4" component="h3" color={Color.white.normal} textAlign="center" mb="1em">
      ...And there’s more
    </Typography>

    <Box
      m="auto"
      py="2.5em"
      maxWidth={{ md: 'md', xs: 'sm' }}
      display="grid"
      gridTemplateColumns={{ md: 'repeat(3, 1fr)', xs: '1fr' }}
      gap={{ md: '2em', xs: 0 }}
      bgcolor={Color.saint.darkest}
      borderRadius="8px"
    >
      {moreFeatures.map(({ title, icon }) => (
        <Box key={title} p="1.5em 1.5em" textAlign="center">
          <Box mb="2em">
            <CloudflareImage src={icon} width={70} height={50} />
          </Box>
          <Typography variant="overline" color={Color.saint.lightest} mb="1em">
            {title}
          </Typography>
        </Box>
      ))}
    </Box>
  </FeaturesContainer>
)

export default Features
